module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header', {
    attrs: {
      "logged": _vm.checkIfUserIsLogged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper-component"
  }, [_c('router-view')], 1), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-736aba34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/screens/Home.vue
// module id = 261
// module chunks = 0